<template>
  <status-string :text="statusValue.text" :class="statusValue.class" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import StatusString from '@/core/components/common/StatusString.vue';
import { TariffScheduleStatus } from '@/graphql/generated';

const props = defineProps<{
  status: TariffScheduleStatus;
  remoteInteraction?: boolean;
  activeRemoting?: boolean;
}>();

const statusValue = computed(() => {
  if (props.status === TariffScheduleStatus.Closed) {
    return {
      text: 'Закрыто',
      class: 'text-red',
    };
  }

  if (props.status === TariffScheduleStatus.Draft) {
    return {
      text: 'Настройка не завершена',
      class: 'text-yellow',
    };
  }

  if (props.remoteInteraction) {
    if (props.activeRemoting) {
      return {
        text: 'Активно',
        class: 'text-green',
      };
    } else {
      return {
        text: 'Не активно',
        class: 'text-ordinary',
      };
    }
  }

  if (props.status === TariffScheduleStatus.OnApproval) {
    return {
      text: 'На модерации',
      class: 'text-blue',
    };
  }

  return {
    text: 'В работе',
    class: 'text-green',
  };
});
</script>
